import { Home, Practice } from "./pages";
import "./App.css";
import "./i18n";
import LangSeletor from "./components/LangSeletor";

function App() {
	const Main = () => {
		switch (window.location.pathname) {
			case "/":
				return <Home />;
			case "/practice":
				return <Practice />;
			default:
				return <div>404 Not Found</div>;
		}
	};

	return (
		<>
			<Main />
			<LangSeletor />
		</>
	);
}

export default App;
